<script setup lang="ts">
import { ref } from 'vue';
import i18n from '@/i18n';
import { useAdminQuoteStore } from '@/store/AdminQuoteStore';

const emits = defineEmits<{ statusEvent: [value: string] }>();

const filterEmit = (status: string) => {
  emits('statusEvent', status);
};

const statisticTotal = ref();
const statisticBooked = ref();
const statisticExpire = ref();
const statisticNew = ref();

const AdminQuoteStore = useAdminQuoteStore();
const getData = async () => {
  await AdminQuoteStore.getReportStatistic();
  statisticTotal.value = AdminQuoteStore.reportStatistic?.TOTAL == null ? 0 : AdminQuoteStore.reportStatistic.TOTAL;
  statisticBooked.value = AdminQuoteStore.reportStatistic?.BOOKED == null ? 0 : AdminQuoteStore.reportStatistic.BOOKED;
  statisticExpire.value = AdminQuoteStore.reportStatistic?.EXPIRED == null ? 0 : AdminQuoteStore.reportStatistic.EXPIRED;
  statisticNew.value = AdminQuoteStore.reportStatistic?.NEW == null ? 0 : AdminQuoteStore.reportStatistic.NEW;
};
getData();
</script>

<template>
  <div class="surface-ground">
    <div class="grid">
      <div id="report-stats-total" class="col-12 md:col-6 lg:col-3">
        <a class="no-underline" href="javascript:" @click="filterEmit('TOTAL')">
          <div class="surface-card shadow-2 p-3 border-round">
            <div class="flex justify-content-between mb-3">
              <div>
                <span class="block font-medium mb-3">{{ i18n.global.t('status.total_quote') }}</span>
                <div class="text-900 font-medium text-xl">{{ statisticTotal }}</div>
              </div>
            </div>
            <span class="text-primary font-medium">{{ statisticTotal }}</span>
            <span>&nbsp;{{ i18n.global.t('status.number_of_quote') }}</span>
          </div>
        </a>
      </div>
      <div id="report-stats-book" class="col-12 md:col-6 lg:col-3">
        <a class="no-underline" href="javascript:" @click="filterEmit('BOOKED')">
          <div class="surface-card shadow-2 p-3 border-round">
            <div class="flex justify-content-between mb-3">
              <div>
                <span class="block font-medium mb-3">{{ i18n.global.t('status.booked_quote') }}</span>
                <div class="text-900 font-medium text-xl">{{ statisticBooked }}</div>
              </div>
            </div>
            <span class="text-primary font-medium">{{ statisticBooked }}</span>
            <span>&nbsp;{{ i18n.global.t('status.number_of_booked_quote') }}</span>
          </div>
        </a>
      </div>
      <div id="report-stats-expired" class="col-12 md:col-6 lg:col-3">
        <a class="no-underline" href="javascript:" @click="filterEmit('EXPIRED')">
          <div class="surface-card shadow-2 p-3 border-round">
            <div class="flex justify-content-between mb-3">
              <div>
                <span class="block font-medium mb-3">{{ i18n.global.t('status.expired_quote') }}</span>
                <div class="text-900 font-medium text-xl">{{ statisticExpire }}</div>
              </div>
            </div>
            <span class="text-primary font-medium">{{ statisticExpire }}</span>
            <span>&nbsp;{{ i18n.global.t('status.number_of_agency_mode') }}</span>
          </div>
        </a>
      </div>
      <div id="report-stats-new" class="col-12 md:col-6 lg:col-3">
        <a class="no-underline" href="javascript:" @click="filterEmit('NEW')">
          <div class="surface-card shadow-2 p-3 border-round">
            <div class="flex justify-content-between mb-3">
              <div>
                <span class="block font-medium mb-3">{{ i18n.global.t('status.received_quote') }}</span>
                <div class="text-900 font-medium text-xl">{{ statisticNew }}</div>
              </div>
            </div>
            <span class="text-primary font-medium">{{ statisticNew }}</span>
            <span>&nbsp;{{ i18n.global.t('status.number_of_agency_mode') }}</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
:deep() {
  .surface-card {
    min-height: 10rem;
  }
}
</style>
